import { render, staticRenderFns } from "./cq-super-powers.vue?vue&type=template&id=2598b60c&scoped=true&"
import script from "./cq-super-powers.vue?vue&type=script&lang=js&"
export * from "./cq-super-powers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2598b60c",
  null
  
)

export default component.exports